import {
    Button,
    InputNumber,
    Spin,
    message,
    Tag,
    Modal,
    Input,
    Switch
} from 'antd';
import React, { useState, useEffect } from 'react'
import { format } from '../App';
import MenuBar from './menu/MenuBar';
// import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
// import gotoPDF from './account/gotoPDF';
import { pad, postData } from '../data/allfunction';
import { useHistory } from 'react-router-dom';
import { delUser, setUser } from '../app/features/user/userSlice';
import moment from 'moment';
const dateFormat = 'DD-MM-YYYY HH:mm:ss'
const ip = process.env.REACT_APP_IP
const QR = process.env.REACT_APP_QR
const { TextArea } = Input;

function CancelPolicy() {
    const history = useHistory()
    const dispatch = useDispatch()
    const { user_id, user, token, retoken } = useSelector(state => {
        return state.user
    })
    // const { user_id, gotoPDF } = props
    const [policy_no, setpolicy_no] = useState(0)
    const [loading, setloading] = useState(false)
    const [oneData, setoneData] = useState({})
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detial, setdetial] = useState('');
    const [no, setno] = useState(null);
    const [day_used, setday_used] = useState(0);
    const [rate_percen, setrate_percen] = useState(0);


    const [editRetrun, seteditRetrun] = useState(false)


    const [moneyBlack, setmoneyBlack] = useState(0)
    const [agentCommit, setagentCommit] = useState(0)
    const [totalPlaBack, settotalPlaBack] = useState(0)

    const [totalPlaBack_edit, settotalPlaBack_edit] = useState(0)
    const [zjireturncustomer, setzjireturncustomer] = useState(0)

    const [returncom, setreturncom] = useState(0)
    // const [newpremuim, setnewpremuim] = useState(0)
    const showModal = () => {
        setIsModalVisible(true);
    };


    useEffect(() => {
        function setSameState() {
            setreturncom(oneData.commission_percen != null ? oneData.commission_percen : oneData.Total_MVL)
            setmoneyBlack(_rate_percen(oneData.premuim, rate_percen))
            setagentCommit(_commission_percen(returncom, oneData.premuim, oneData.Text116))
            // settotalPlaBack(_totalPlaBack(
            //     _rate_percen(oneData.premuim, rate_percen),
            //     _commission_percen(returncom, oneData.premuim)
            // ))
            settotalPlaBack(oneData.premuim * (rate_percen / 100))
            // if (oneData.paid === 0) {
            //     setnewpremuim(0)
            // } else {
            //     setnewpremuim(
            //         oneData.premuim -
            //         _totalPlaBack(
            //             _rate_percen(oneData.premuim, rate_percen),
            //             _commission_percen(returncom, oneData.premuim)
            //         )
            //     )
            // }

        }
        setSameState()
    }, [oneData, rate_percen])
    function _rate_percen(premuim, rate_percen) {
        return (premuim * (rate_percen / 100))
    }
    function _commission_percen(commission_percen, premuim, Text116) {
        // console.log(commission_percen, premuim, ((commission_percen / 100) * premuim), Text116 / 100)
        let commission_before_tax = (commission_percen / 100) * premuim
        let commission_ater_tax = commission_before_tax * (Text116 / 100)
        // return (commission_percen / 100) * premuim
        // console.log(commission_before_tax - commission_ater_tax)
        return commission_before_tax - commission_ater_tax
    }
    // function _totalPlaBack(_rate_percen, _commission_percen) {
    //     let total = _rate_percen - _commission_percen
    //     // settotalPlaBack(total)
    //     return total
    // }

    const handleOk = () => {
        setIsModalVisible(false);
        let link = `${ip}sell_online/cancel`
        let dataSetForGet
        if (editRetrun) {
            // ບັນຊີໃສ່ເງິນດ້ວຍຕົນເອງ
            dataSetForGet = {
                detial: moment(Date.now()).format(dateFormat) + '=>ປ້ອນຄ່າເອງ ຄ່າທຳນຽມໂຕເກົ່າແມ່ນ' + oneData.premuim + detial,
                cancel_user: user,
                no: no,
                newpremuim: oneData.premuim - totalPlaBack_edit,
                newtotal_premuim: (oneData.premuim - totalPlaBack_edit) + oneData.vat + oneData.register,
                commission: (oneData.premuim * (returncom / 100)) - ((oneData.premuim * (returncom / 100)) * (oneData.Text116 / 100)) - zjireturncustomer
            }
        } else {
            //ລະບົບຄິດໄລເງິນ
            // console.log(oneData.premuim, totalPlaBack)
            dataSetForGet = {
                detial: moment(Date.now()).format(dateFormat) + '=>ຄ່າທຳນຽມໂຕເກົ່າແມ່ນ' + oneData.premuim + detial,
                cancel_user: user,
                no: no,
                newpremuim: oneData.premuim - totalPlaBack,
                newtotal_premuim: (oneData.premuim - totalPlaBack) + oneData.vat + oneData.register,
                commission: (oneData.premuim * (returncom / 100)) - ((oneData.premuim * (returncom / 100)) * (oneData.Text116 / 100)) - (agentCommit * (rate_percen / 100))
                //    ຄ່າຄອມ - ອາກອນລາຍໃດ້ - ຕົວແທນຕ້ອງສົ່ງຄືນໃຫ້
            }
        }
        // console.log('dataSetForGet117')
        // console.log(dataSetForGet)

        function setWhenUpdate(result) {
            console.log(result)
            if (result.data.data.changedRows === 1) {
                message.info('ຍົກເລີກສັນຍາສຳເຫຼັ້ດ')
                setdetial(null);
                setno(null);
                setoneData({})
                setpolicy_no(0)
            } else {
                message.error('ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່')
            }

        }
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)

    };
    const getCancelRate = () => {
        let link = `${ip}sell_online/cancelRate`
        let dataSetForGet = {
            day: oneData.start
        }
        function setWhenUpdate(result) {

            if (result.data.status === 200) {
                const { data } = result.data
                // console.log('canclepolicy 143')
                // console.log(data[0])
                setday_used(data[0].day_used)

                setrate_percen(data[0].rate_percen)
                // if (oneData.paid === 1) {
                //     setrate_percen(data[0].rate_percen)
                // } else {
                //     setrate_percen(0)
                // }
            } else {
                message.warning(`ເກີດຂໍ້ຜິດພາດໃນການດືງຂໍ້ມູນ`);
            }

        }
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)




    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    function getOneData() {
        let link = `${ip}sell_online/getOne`
        let dataSetForGet = { no: policy_no, user: user_id }
        function setWhenUpdate(result) {
            if (result.data.status === 200) {
                const { rows } = result.data
                // console.log(171)
                // console.log(rows)
                if (rows.length > 0) {
                    setoneData(rows[0])
                } else {
                    setoneData({})
                    message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
                }
                setTimeout(() => {
                    setloading(false)
                }, 100);
            } else {
                setTimeout(() => {
                    setloading(false)
                }, 100);

                // console.log(result)
            }
        }
        postData(message, link, dataSetForGet, token, retoken, user, dispatch, delUser, setUser, history, setWhenUpdate)

    }
    return (
        <>
            <MenuBar />
            <div className="container text-center mt-3">
                <h4>ຍົກເລີກ ສັນຍາ ປະກັນໄພລົດ</h4>
            </div>
            <div className="container ">
                {loading &&
                    <div style={{
                        position: 'absolute',
                        top: '11%',
                        left: '45%'
                    }}>
                        <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
                    </div>}


                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flex: 4 }}>
                        <InputNumber
                            style={{ width: '100%' }}
                            onChange={(v) => setpolicy_no(v)}
                        // value={policy_no}
                        />

                    </div>
                    <div style={{ flex: 1, marginLeft: 5 }}>
                        <Button disabled={policy_no > 0 ? false : true} onClick={() => {
                            getOneData()
                        }} style={{ width: '100%' }} type='primary'> ຄົ້ນຫາ </Button>
                    </div>
                </div>
                <table className='table table-striped'>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ເລກທີສັນຍາ</th>
                            <th>ເລກທະບຽນ</th>
                            <th>ຄ່າທຳນຽມຕົ້ນ</th>
                            <th>ເລກຈັກ</th>
                            <th>ເລກຖັງ</th>
                            <th>ຜູ້ໄດ້ຮັບປະກັນໄພ</th>
                            <th>ປະເພດການຄຸ້ມກັນ</th>
                            <th>ວັນສິ້ນສຸດການຄຸ້ມກັນ</th>
                            <th>ຕົວແທນຂາຍ</th>
                            <th>ສະຖານະຂອງສັນຍາ</th>
                            <th>ຍົກເລີກສັນຍາ</th>
                        </tr>
                    </thead>
                    {oneData.no &&
                        <tbody>
                            <tr >
                                <td>1</td>
                                <td>
                                    {/* <Link to={gotoPDF(oneData.cover) + oneData.no} target="_blank"><Button type="dashed">{pad(oneData.no)}</Button></Link> */}
                                    {oneData.policy_type === 'MS' ? 'MS-' : null}{pad(oneData.no)}
                                </td>
                                <td>{oneData.o_plate}</td>
                                <td style={{ textAlign: 'right' }}>{format(oneData.premuim)}</td>
                                <td>{oneData.o_engine}</td>
                                <td>{oneData.o_chassis}</td>
                                <td>{oneData.o_name}</td>
                                <td>{oneData.cover}</td>
                                <td>{moment(oneData.end).format("DD-MM-YYYY")}</td>
                                <td>{oneData.userText}</td>
                                <td>
                                    {oneData.cancel === 1 ? <Tag style={{ cursor: 'pointer' }} onClick={() => handleClick(oneData.no)} color="red">ຖືກຍົກເລີກ</Tag> : <Tag style={{ cursor: 'pointer' }} onClick={() => handleClick(oneData.no)} color="geekblue">ບໍ່ຖືກຍົກເລີກ</Tag>}
                                </td>
                                <td>
                                    {oneData.cancel !== 1 && <Button danger onClick={() => {
                                        setno(oneData.no)
                                        showModal()
                                        // console.log(oneData)
                                        getCancelRate()
                                    }}>
                                        ຍົກເລີກ
                                    </Button>}
                                </td>

                            </tr>
                        </tbody>
                    }
                </table>
                <Modal
                    title={"ຟອມຍົກເລີກສັນຍາເລກທີ: " + no}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={[
                        <Button key="back" type="primary" onClick={handleCancel}>
                            ກັບຄືນ
                        </Button>,
                        detial !== '' && <Button key="submit" danger onClick={handleOk}>
                            ຢືນຢັນຍົກເລີກສັນຍາ
                        </Button>
                    ]}
                >
                    {/* {JSON.stringify(oneData)} */}

                    <div className='mb-1'>
                        ໃສຈຳນວນເງິນດ້ວຍຕົວເອງ:
                        <Switch
                            checkedChildren="ເປີດ"
                            unCheckedChildren="ປິດ"
                            checked={editRetrun}
                            onChange={(e) => seteditRetrun(e)}

                        />
                    </div>

                    {editRetrun ?
                        <>
                            <div className='mb-1'>
                                <b>ໃສ່ຈຳນວນເງິນ ZJI ຄືນໃຫ້ກັບລູກຄ້າ</b>
                                <InputNumber
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder='ໃສ່ຈຳນວນເງິນ'
                                    value={totalPlaBack_edit}
                                    onChange={(e) => settotalPlaBack_edit(e)}
                                />
                            </div>
                            <div className='mb-1'>
                                <b>ໃສ່ຈຳນວນເງິນຕົວແທນຄືນໃຫ້ ZJI</b>
                                <InputNumber
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder='ໃສ່ຈຳນວນເງິນ'
                                    value={zjireturncustomer}
                                    onChange={(e) => setzjireturncustomer(e)}
                                />
                            </div>
                        </>
                        :
                        <ul>
                            <li>
                                ສະຖານະການຊຳລະ
                                {oneData.paid === 1 ?
                                    <Tag color="geekblue">ຊຳລະສົມບູນແລ້ວ</Tag>
                                    :
                                    <Tag color="red">ລໍຖ້າການຊຳລະ</Tag>
                                }

                            </li>
                            <li>
                                ສັນຍາອອກວັນທີ {moment(oneData.start).format('DD-MM-YYYY HH:mm:ss')}
                            </li>
                            <li>
                                ຈຳນວນວັນທີ່ຖືກຄຸ້ມກັນ {day_used}
                            </li>
                            <li>
                                ຄ່າທຳນຽມຕົ້ນ {format(oneData.premuim)}
                            </li>

                            <li>
                                ຈຳນວນເງິນທີ່ຕ້ອງຈ່າຍຄືນລູກຄ້າ {rate_percen}% ເປັນເງິນ
                                {"  " +
                                    format(moneyBlack
                                    )
                                }
                            </li>
                            <li>
                                ຕົວແທນຕ້ອງຊຳລະເງິນຄືນ ZJI {rate_percen}% ຈາກລາຍໃດ້ຄ່າຄອມມິດຊັ່ນ {returncom} %
                                ເປັນເງິນ
                                {/* {
                                    format(
                                        (oneData.premuim * (returncom / 100)) - ((oneData.premuim * (returncom / 100)) * (oneData.Text116 / 100))
                                        -
                                        (agentCommit * (rate_percen / 100))
                                    )
                                }

                                *** */}
                                {

                                    format(
                                        agentCommit * (rate_percen / 100)
                                    )}
                            </li>
                        </ul>
                    }


                    <TextArea
                        placeholder="ກະລຸນາໃສ່ລາຍລະອຽດ ການຍົກເລີກສັນຍາ"
                        showCount
                        maxLength={150}
                        defaultValue={detial}
                        onChange={e => setdetial(e.target.value)}
                    />
                </Modal>
            </div>
        </>
    )
    function handleClick(no) {
        window.open(QR + no);
    }
}

export default CancelPolicy